// Refuses to render owner-only pages (the dashboard) inside a frame.
//
// The dashboard edits live widgets and reads visitors' leads, so a page on
// another site must not be able to frame it and trick a signed-in owner into
// clicking through it (clickjacking). The proper control is a frame-ancestors
// response header, but this is a Render static site with no header config in
// the repo, and frame-ancestors is ignored in a <meta> CSP. So: break out of
// the frame if we can, and render nothing clickable if we cannot (a sandboxed
// frame blocks top navigation).
//
// ONLY for owner pages. Widget pages and the standalone tool pages must stay
// frameable – embedders iframe them.
import React, { useEffect } from 'react';

export function isFramed(win = window) {
  try {
    return win.self !== win.top;
  } catch (e) {
    return true; // cross-origin top: reading it throws, which means framed
  }
}

export default function FrameGuard({ children }) {
  const framed = isFramed();

  useEffect(() => {
    if (!framed) return;
    try {
      window.top.location.href = window.location.href;
    } catch (e) {
      // Sandboxed without allow-top-navigation – the message below stays.
    }
  }, [framed]);

  if (!framed) return children;
  return (
    <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
      The KarbonKit dashboard can't be shown inside another page.{' '}
      <a href={window.location.href} target="_blank" rel="noopener noreferrer">
        Open it in its own tab
      </a>
      .
    </div>
  );
}
